import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConfigMenuData } from "../../../config/appMenu";
import { ApiSchemaMenuBuilder } from "../../../models/apiSchema/login";
import { MenuItemType } from "../../../models/menuItem";
import { StorageUserData } from "../../localStorage";

type SliceUserState = {
  menuItems: MenuItemType[];
};

function ResolveMenuItems(data?: ApiSchemaMenuBuilder): MenuItemType[] {
  if (data) {
    const menuByRole = ConfigMenuData[data.roles];
    if (menuByRole) {
      const filteredMenu = menuByRole.filter((menu) =>
        menu.children
          ? data.menuGroups.some((mg) => mg.groupName === menu.displayName)
          : data.menus.some((m) => m === menu.displayName)
      );
      return filteredMenu;
    }
  }
  return [];
}

function InitSliceUser(): SliceUserState {
  const menuItemData = StorageUserData.Menu;
  const menuItems = ResolveMenuItems(menuItemData);
  return {
    menuItems,
  };
}

const sliceUser = createSlice({
  name: "sliceUser",
  initialState: InitSliceUser(),
  reducers: {
    SetMenuItems: (
      state,
      action: PayloadAction<ApiSchemaMenuBuilder>
    ): void => {
      StorageUserData.Menu = action.payload;
      state.menuItems = ResolveMenuItems(action.payload);
    },
  },
});

export const { SetMenuItems: setMenuItems } = sliceUser.actions;

export const ReducerUser = sliceUser.reducer;
export const ActionUser = sliceUser.actions;
